import React from 'react';
import {
  Grid,
  Typography,
  CircularProgress,
  makeStyles,
  Button,
} from '@material-ui/core';
import { X, Check } from 'react-feather';
import { colors } from 'design-system';
import FileUploadState from '../../../../models/helperTypes/FileUploadState';

const useStyles = makeStyles({
  cancel: {
    color: colors.bright_turquoise,
    fontSize: '14px',
    fontWeight: 'bolder',
  },
});

type Props = {
  status: FileUploadState;
  onCancelAction: () => void;
};

function renderStructure({
  status,
  icon,
  msg,
}: {
  status: FileUploadState;
  icon: JSX.Element;
  msg: React.ReactNode;
}): JSX.Element {
  return (
    <Grid item xs={12} container alignItems="center" data-testid={status}>
      <Grid item xs={2} container justifyContent="center">
        {icon}
      </Grid>
      <Grid item xs={10}>
        {msg}
      </Grid>
    </Grid>
  );
}

const RegistryUploadStatus = ({
  status,
  onCancelAction,
}: Props): JSX.Element => {
  const classes = useStyles();
  switch (status) {
    case 'uploading': {
      return renderStructure({
        status,
        msg: (
          <>
            <span>
              <Typography variant="caption">
                Cargando el registro vehícular. En caso que no cargue,
              </Typography>
            </span>
            <Button
              className={classes.cancel}
              onClick={onCancelAction}
              data-testid="cancel-action"
            >
              TOQUE AQUÍ
            </Button>
            <span>
              <Typography variant="caption">
                para cancelar y subirlo nuevamente.
              </Typography>
            </span>
          </>
        ),
        icon: <CircularProgress style={{ width: '26px', height: '26px' }} />,
      });
    }
    case 'failed': {
      return renderStructure({
        status,
        msg: (
          <Typography variant="caption">
            La foto del registro vehicular no cargó correctamente, por favor
            tome la foto nuevamente.
          </Typography>
        ),
        icon: <X color="red" style={{ width: '26px', height: '26px' }} />,
      });
    }
    case 'success': {
      return renderStructure({
        status,
        msg: (
          <Typography variant="caption">
            La foto del registro vehicular cargó con éxito.
          </Typography>
        ),
        icon: <Check color="green" style={{ width: '26px', height: '26px' }} />,
      });
    }
    default: {
      return <div data-testid="default" />;
    }
  }
};

export default RegistryUploadStatus;
